/**
 * Créneaux horaires fixes adaptés aux prestations longues (jusqu'à 2h)
 * 12h supprimé : pas le temps pour 2h avant pause déjeuner
 * 17h supprimé : prestation de 2h finirait après fermeture (18h)
 */
export const HOURLY_TIME_SLOTS = [
  '09:00', '10:00', '11:00', 
  '14:00', '15:00', '16:00'
] as const;

/**
 * Type pour les créneaux horaires valides
 */
export type HourlyTimeSlot = typeof HOURLY_TIME_SLOTS[number];

/**
 * Vérifie si un créneau horaire est valide
 */
export function isValidTimeSlot(timeSlot: string): timeSlot is HourlyTimeSlot {
  return HOURLY_TIME_SLOTS.includes(timeSlot as HourlyTimeSlot);
}
